import { OverlayProvider } from "@/components/modal/OverlayProvider";
import { OverlayContext, OverlayOwnerContext } from "@/components/modal/overlay-context";
import { ToastViewport } from "@/components/toast/ToastViewport";
import { FloatingContext } from "@/components/TooltipV2";
import { useContext } from "react";
import { createPortal } from "react-dom";

export function CustomToaster() {
  const context = useContext(OverlayContext);
  if (!context)
    return (
      <OverlayProvider>
        <CustomToaster />
      </OverlayProvider>
    );
  if (!context.toastRoot) return null;
  return createPortal(
    <OverlayOwnerContext.Provider value={null}>
      <FloatingContext.Provider value={context.toastRoot}>
        <ToastViewport />
      </FloatingContext.Provider>
    </OverlayOwnerContext.Provider>,
    context.toastRoot,
  );
}
